import { render, staticRenderFns } from "./VoiceCallModal.vue?vue&type=template&id=01dd5e1e&scoped=true"
import script from "./VoiceCallModal.vue?vue&type=script&lang=js"
export * from "./VoiceCallModal.vue?vue&type=script&lang=js"
import style0 from "./VoiceCallModal.vue?vue&type=style&index=0&id=01dd5e1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dd5e1e",
  null
  
)

export default component.exports